import React from 'react'
import Pagination from 'react-bootstrap/Pagination'
import {
   useGridApiContext,
   useGridSelector,
   gridPageSelector,
   gridPageCountSelector
} from '@mui/x-data-grid'

const CustomPagination = () => {
   const apiRef = useGridApiContext()
   const page = useGridSelector(apiRef, gridPageSelector)
   const pageCount = useGridSelector(apiRef, gridPageCountSelector)

   const handleChange = (newPage) => {
      if (newPage >= 0 && newPage < pageCount) {
         apiRef.current.setPage(newPage)
      }
   }

   const renderPageItems = () => {
      const items = []

      if (pageCount <= 6) {
         for (let i = 0; i < pageCount; i++) {
            items.push(
               <Pagination.Item key={i} active={i === page} onClick={() => handleChange(i)}>
                  {i + 1}
               </Pagination.Item>
            )
         }
         return items
      }

      const firstPages = [0, 1, 2]
      const lastPages = [pageCount - 3, pageCount - 2, pageCount - 1].filter(p => p >= 0)

      const isInFirstGroup = page <= 2
      const isInLastGroup = page >= pageCount - 3
      const isInMiddle = !isInFirstGroup && !isInLastGroup


      firstPages.forEach((p) => {
         items.push(
            <Pagination.Item key={p} active={p === page} onClick={() => handleChange(p)}>
               {p + 1}
            </Pagination.Item>
         )
      })


      if (isInMiddle || isInLastGroup) {
         items.push(<Pagination.Ellipsis key="ellipsis1" disabled />)
      }


      if (isInMiddle) {
         items.push(
            <Pagination.Item key={page} active onClick={() => handleChange(page)}>
               {page + 1}
            </Pagination.Item>
         )
      }


      if (isInMiddle || isInFirstGroup) {
         items.push(<Pagination.Ellipsis key="ellipsis2" disabled />)
      }


      lastPages.forEach((p) => {
         if (!firstPages.includes(p)) {
            items.push(
               <Pagination.Item key={p} active={p === page} onClick={() => handleChange(p)}>
                  {p + 1}
               </Pagination.Item>
            )
         }
      })

      return items
   }

   return (
      <div
         style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: '1rem',
            marginBottom: '1rem'
         }}
      >
         {/* Кнопка Prev */}
         <Pagination className="custom-pagination mb-0">
            <Pagination.Prev
               onClick={() => handleChange(page - 1)}
               disabled={page === 0}

            >
               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M15.8327 9.99935H4.16602M4.16602 9.99935L9.99935 15.8327M4.16602 9.99935L9.99935 4.16602" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className='prev_styles'>
                     Previous
                  </span>
               </div>
            </Pagination.Prev>
         </Pagination>


         <Pagination className="custom-pagination mb-0">{renderPageItems()}</Pagination>


         <Pagination className="custom-pagination mb-0">
            <Pagination.Next
               onClick={() => handleChange(page + 1)}
               disabled={page >= pageCount - 1}
            // style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span className='next_styles'>
                     Next
                  </span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M4.16602 9.99935H15.8327M15.8327 9.99935L9.99935 4.16602M15.8327 9.99935L9.99935 15.8327" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
               </div>
            </Pagination.Next>
         </Pagination>
      </div>
   )
}

export default CustomPagination
